// check if browser is internet explorer
// returns version number eg. 11
export const isInternetExplorer = () =>
  (typeof document !== 'undefined' &&
    (document as Document & { documentMode?: number }).documentMode) ||
  0

// Check browser media query. To detect media "print", for example
export const isMedia = (media: string): boolean =>
  typeof window.matchMedia !== 'undefined' && window.matchMedia(media).matches
